module.exports = __webpack_public_path__ + "static/sport/h5-bg.47d62ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/september10/h5-bg.jpg
// module id = ktwf
// module chunks = 0